<template>
  <div class="resident-warpper">
    <div class="bg-white">
      <div class="flex align-center justify-between">
        <div class="flex-sub margin-right">
          <div class="flex align-center">
            <div class="margin-right">
              <router-link to="/home/team-member"> <el-button type="primary" plain>志愿者</el-button></router-link>
              <el-button type="primary"  >志愿者队长</el-button>
            </div>

            <div class="flex align-center margin-right-sm  ">
              <span>姓<i style="padding-left: 14px;"></i>名：</span>
              <el-input v-model="name" placeholder="请输入姓名" class="flex-sub"></el-input>
            </div>
            <div class="flex align-center margin-right-sm  ">
              <span>手机号：</span>
              <el-input v-model="phone" placeholder="请输入手机号" class="flex-sub"></el-input>
            </div>
            <el-button type="primary" @click="hanldSearch">搜索</el-button>
          </div>
        </div>
<!--        <el-button type="primary" @click="delAllJnb">一键清除金暖宝(志愿者队长+志愿者)</el-button>-->
      </div>

      <div class="flex align-center justify-between margin-tb-sm">
        <div>
          共{{ total }}条数据
        </div>
        <div>
          <el-button
            size="small"
            type="warning"
            @click="exportWuyeguanjiaList"
          >导出志愿者队长信息
          </el-button>
        </div>
      </div>

      <el-table
        :data="residentList"
        header-row-class-name="table-header"
        row-class-name="table-row"
        alig="center"
        border
        style="width: 100%"
      >
        <el-table-column width="70" type="index" align="center" label="序号"></el-table-column>
        <el-table-column label="志愿者队长" prop="name"></el-table-column>
        <el-table-column label="手机号" prop="username"></el-table-column>
        <el-table-column label="完成的服务项数" prop="service_num"></el-table-column>
        <el-table-column label="积分" prop="integral"></el-table-column>
<!--        <el-table-column label="金暖宝" prop="jinnuanbao"></el-table-column>-->
<!--        <el-table-column label="银暖宝" prop="yinnuanbao"></el-table-column>-->
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div class="table-operate">
              <el-button
                size="small"
                type="primary"
                @click="detailItem(scope.row.id)"
              >查看
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="residentList.length > 0"
        class="page-all"
        background
        @current-change="getResidentList"
        :current-page.sync="page"
        :page-size="limit"
        layout="prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { exportWuyeguanjiaList, getWuyeguanjiaList, resetJinnuanbao} from "@/api/weilao";


export default {
  name: "team-admin",
  data() {
    return {
      name: '',
      phone: '',
      page: 1,
      limit: 10,
      total: 0,
      residentList: [],

    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  created() {
    this.$emit("setIndex", '/home/team-member', "双暖为老 / 志愿者队长", false);
    this.getResidentList()
  },
  components: {},
  methods: {

    //  志愿者队长数据导出
    async exportWuyeguanjiaList(){
      let _state = await exportWuyeguanjiaList(
        this.name,
        this.phone,
        6
      )
      let blob = _state.data
      var downloadElement = document.createElement('a');
      var href = window.URL.createObjectURL(blob); //创建下载的链接
      downloadElement.style.display = 'none';
      downloadElement.href = href;
      downloadElement.setAttribute('download', '志愿者队长数据.xls');
      document.body.appendChild(downloadElement);
      downloadElement.click(); //点击下载
      document.body.removeChild(downloadElement); //下载完成移除元素
      window.URL.revokeObjectURL(href); //释放掉blob对象
    },



    delAllJnb() {
      this.$confirm('您确定要清除志愿者队长和志愿者的金暖宝吗吗？', "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureDel();
      });
    },
    async sureDel() {
      const res = await resetJinnuanbao('', '', '')
      if (res.status === 200) {
        this.$message.success(res.info)
        this.getResidentList()
      } else {
        this.$message.error(res.info)
      }

    },
    //  查看详情
    detailItem(id) {
      this.$router.push('/home/team-admin-detail/' + id)
    },
    //  搜索
    hanldSearch() {
      this.page = 1
      this.getResidentList()
    },

    //  获取志愿者队长列表
    async getResidentList() {
      let _data = await getWuyeguanjiaList(
        this.name,
        this.phone,
        6,
        this.page,
        this.limit,
      )
      this.residentList = _data.data
      this.total = _data.total_number
    },

  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">

</style>
